// eslint-disable-next-line simple-import-sort/imports
import "./instrument";
import React, { StrictMode } from "react";
import { Provider as ReduxProvider } from "react-redux";
import Highcharts from "highcharts";
import "./index.css";
import { createRoot } from "react-dom/client";
import AuthorisedUser from "@/components/AuthorisedUser";
import { LONDON_TZ } from "@/constants/date.constants";
import { store } from "@/store";
import { getHighchartsPaletteOption } from "./helpers/palette.helpers";
import AuthProvider from "./providers/AuthProvider";
import NimbusGlobalProvider from "./providers/NimbusGlobalProvider";

Highcharts.setOptions({
  time: {
    timezone: LONDON_TZ,
  },
  palette: getHighchartsPaletteOption(),
});

async function enableMocking() {
  if (import.meta.env.VITE_MOCKED !== "true") {
    return;
  }

  const { worker } = await import("./mocks/browser");

  // Service worker served from root via Vite middleware to intercept /api/* requests
  return worker.start({
    serviceWorker: {
      url: `/mockServiceWorker.js`,
    },
    onUnhandledRequest: "warn",
  });
}

enableMocking().then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <ReduxProvider store={store}>
        <AuthProvider>
          <AuthorisedUser
            component={<NimbusGlobalProvider />}
            dataTestId="nimbus-app-ui"
          />
        </AuthProvider>
      </ReduxProvider>
    </StrictMode>
  );
});
